import Vue from 'vue';
import Router from 'vue-router';
import store from '../store.js'
import LoginComponent from '../components/LoginComponent.vue'
import RegisterComponent from '../components/RegisterComponent.vue'
import HomeComponent from '../components/HomeComponent.vue'
import UserTable from '../components/UserTable.vue'
import ModelTable from '../components/ModelTable.vue'
import ModelList from '../components/ModelList.vue'
import AdminComponent from '../components/AdminComponent.vue'
import SemanticShiftTable from '../components/SemanticShiftTable.vue'
import SemanticShiftVisualization from '../components/SemanticShiftVisualization.vue'
import DocumentClassification from '../components/DocumentClassification.vue'
import LLMChat from '../components/LLMChat.vue'
import SequenceLabelling from '../components/SequenceLabelling.vue'
import MorphologicalSegmentation from '../components/MorphologicalSegmentation.vue'


Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeComponent
    },
    {
      path: '/login',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterComponent
    },
    {
      path: '/modellist',
      name: 'ModelList',
      component: ModelList
    },
    {
      path: '/admin/usertable',
      name: 'usertable',
      component: UserTable,
    },
    {
      path: '/admin/modeltable',
      name: 'modeltable',
      component: ModelTable,
    },
    {
      path: '/semanticshifttable/:model_id',
      name: 'semanticshifttable',
      component: SemanticShiftTable,
      props: {
        header: true,
        content: true
      }
    },
    {
      path: '/semanticshiftvisualization/:model_id',
      name: 'semanticshiftvisualization',
      component: SemanticShiftVisualization,
      props: {
        header: true,
        content: true
      }
    },
    {
      path: '/documentclassification/:model_id',
      name: 'documentclassification',
      component: DocumentClassification,
      props: {
        header: true,
        content: true
      }
    },
    {
      path: '/sequencelabelling/:model_id',
      name: 'sequencelabelling',
      component: SequenceLabelling,
      props: {
        header: true,
        content: true
      }
    },
    {
      path: '/LLMChat/:model_id',
      name: 'LLMChat',
      component: LLMChat,
      props: {
        header: true,
        content: true
      }
    },
    {
      path: '/wordsegmentation',
      name: 'wordsegmentation',
      component: MorphologicalSegmentation
    },
    {
      path: '/admin',
      name: 'AdminComponent',
      component: AdminComponent
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router